export default __webpack_public_path__ + "static/media/jobs_img.c892eab5.png";